import { FormControl, TextField } from "@material-ui/core";
import clsx from "clsx";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import React, { Component } from "react";
import axios from "axios";
import swal from "sweetalert";
import AppConfig from "../../../../config/AppConfig";

class MasaStudi extends Component {
  
    state = {
      ref_data : [],
      display: false,
    }
    componentDidMount(){
      let data_ref = []
      let no = 0;
      for (var key in this.props.ref_data) {
        if (this.props.ref_data.hasOwnProperty(key)) {
          data_ref[no] = {
            "name" : key,
            "indicator" : this.props.ref_data[key],
            "value": (this.props.ref_data[key].target !== undefined) ? this.props.ref_data[key].target : 0,
            "value_sks": (this.props.ref_data[key].target_sks !== undefined) ? this.props.ref_data[key].target_sks : 0,
          }
          no++;
        }
      }
      if(this.state.display === false){
        this.setState({
          display: true,
          ref_data: data_ref,
        })
      }
    }
    handleSaveTarget = async(e) =>{
      e.preventDefault();
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }
      let data = this.state.ref_data;
      // console.log("data = ", data)
      if(data !== undefined){
        swal({
            title: "Simpan Masa Studi ?",
            text: "Lakukan penyimpanan target Masa Studi berdasarkan Program",
            icon: "warning",
            buttons: true,
            dangerMode: false,
        }).then((Agree) =>{
          if(Agree){
            
            let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
            this.setState({display: true});
            let datas = this.state.ref_data;
            let arrayLength = datas.length;
            for(var i=0; i < arrayLength; i++){
              var formData = new FormData();
              formData.append('data[id_sp]', sessiondata.i_idunit);
              formData.append('data[id_point]', 1);
              formData.append('data[kelompok_jenjang]', datas[i].name);
              formData.append('data[value]', datas[i].value);
              formData.append('data[value_sks]', datas[i].value_sks);

              axios.post(AppConfig.SaveTarget + session, formData).then(res => {
                swal({
                  title: "Penyimpanan Berhasil!",
                  text: "Target Masa Studi Berhasil Disimpan.",
                  icon: "success",
                  dangerMode: false,
                })
              }).catch(err=>{
                swal({
                  title: "Penyimpanan Gagal!",
                  text: "Target Masa Studi Gagal Disimpan.",
                  icon: "error",
                  dangerMode: false,
                })
              })
            }
          }
        })
      }else{
        swal({
          title: "Data Not Found",
          text: "Something's Wrong!",
          icon: "error",
          // buttons: true,
          dangerMode: false,
        })
      }
      
     
    }
    onInputChange = (e, id) => {
      var list = Object.keys(this.state.ref_data).map((key) => [Number(key), this.state.ref_data[key]])
      let items = [...list];
      let item = {...items[id]};
      item[1].value = e.target.value;
      item[1].value_sks = item[1].value_sks;
      items[id] = item;
      // console.log(items);
      this.setState({items})
      // console.log("ISI = ", item)
      // console.log("data = ", this.state.ref_data)
    }
    onInputChangeSKS = (e, id) => {
      var list = Object.keys(this.state.ref_data).map((key) => [Number(key), this.state.ref_data[key]])
      let items = [...list];
      let item = {...items[id]};
      item[1].value = item[1].value;
      item[1].value_sks = e.target.value;
      items[id] = item;
      this.setState({items})
      // console.log("ISI = ", item)
      // console.log("data = ", this.state.ref_data)
    }
    render(){
      // console.log("DATA EXAMPLE",this.state.ref_data_example);
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let {alert, button}= this.state;
        let ref = this.state.ref_data;
        let view = [];
        if(ref !== undefined){
          view = <>
          {
            ref.map((list,i)=>
                (list.indicator.minimum_value !== undefined) ? <tr>
                <td className="font-size-sm"><b>{list.name}</b></td>
                <td style={{textAlign:'center'}}>
                  <span className="text-dark-75  d-block font-size-sm">
                    {list.indicator.minimum_value}
                  </span>
                </td>
                <td>
                    <div>
                    <FormControl className="form-control">
                          <TextField
                              id="standard-dense"
                              onInput = {(e) =>{
                                e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,1)
                              }}
                              InputProps={{ inputProps: { min: 0, max: list.indicator.minimum_value } }}
                              label="Maksimal tahun"
                              type="number"
                              defaultValue={(list.indicator.target !== undefined) ? list.indicator.target : list.value}
                              className={clsx()}
                              margin="dense"
                              onChange={(e) => this.onInputChange(e, i)}
                          />
                      </FormControl>
                    </div><br/>
                </td>
                <td style={{textAlign:'center'}}>
                  <span className="text-dark-75  d-block font-size-sm">
                    {list.indicator.beban_belajar_minimal}
                  </span>
                </td>
                <td>
                    <div>
                    <FormControl className="form-control">
                          <TextField
                              id="standard-dense"
                              label="Minimal SKS"
                              type="number"
                              defaultValue={(list.indicator.target_sks !== undefined) ? list.indicator.target_sks : list.value_sks}
                              className={clsx()}
                              margin="dense"
                              onChange={(e) => this.onInputChangeSKS(e, i)}
                          />
                      </FormControl>
                    </div><br/>
                </td>
              </tr>
              :""
            )
          }
          </>;
        }
        // console.log("data = ", this.state.ref_data)
        // console.log(" ID POINT = ", this.state.id_point)
        // console.log(" ID PT = ", this.state.id_pt_4)
        // console.log(" value = ", this.state.doktor)
        return(
            <>
            {/* begin::Body */}
              <div className="card-body py-0 px-0">
                {/* begin::Table */}
                <div className="table-responsive" bordered={false}>
                  <table
                    className="table  table-vertical-center"
                    id="kt_advance_table_widget_1"
                  >
                      
                    <thead>
                      <tr className="text-left text-white" style={{backgroundColor:'#3047ad'}}>
                        <th style={{ minWidth: "150px" }}>MASA STUDI MAKSIMAL PADA PROGRAM PENDIDIKAN</th>
                        <th style={{ minWidth: "150px", textAlign:'center' }}>SNDIKTI</th>
                        <th style={{ minWidth: "150px" }}>PENETAPAN PERGURUAN TINGGI</th>
                        <th style={{ minWidth: "150px" }}>BEBAN BELAJAR MINIMAL SNDIKTI</th>
                        <th style={{ minWidth: "150px" }}>PENETAPAN PERGURUAN TINGGI</th>
                      </tr>
                    </thead>
                    <tbody>
                      {view}
                    </tbody>
                  </table>
                </div>
                {/* end::Table */}
              </div>
              <div className="row">
                  <div className="col-md-12 text-center">
                  <div className="card-toolbar">
                  <span>
                    <i className="text-danger" style={{fontSize:'12px'}}>{alert}</i>
                  </span><br/>
                  {
                    sessiondata.i_idrole === 3 ?
                    
                  <button disabled={button} onClick={this.handleSaveTarget}
                      className="btn btn-primary font-weight-bolder font-size-sm"
                    >
                      <span className="svg-icon svg-icon-lg svg-icon-light">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Save.svg"
                          )}
                          className="h-50 align-self-center"
                        ></SVG>
                      </span>
                      &nbsp; &nbsp;Simpan Masa Studi
                    </button>
                    :''
                  }
                </div>
                  </div>
                </div>
            </>
        )
    }
}
export default MasaStudi;

